import { lazy } from 'react';
export var GiveKudosLauncherLazy = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_lazy-give-kudos" */
  './main');
});